module.exports = __webpack_public_path__ + "static/media/about-image-1.3d22933e.png";